import get from 'lodash/get'
import isArray from 'lodash/isArray'
export const indexByLabel = (products, collectionOrder, fallback = 'Shop All') => {
  let productMap = {}
  for (let product of products) {
    // JGUNTHER: Create a product map of section titles created from
    // collection label accentuate field
    const sectionTitle = get(
      product,
      'metafieldsMap.collection_label.value',
      fallback
    )
    // create or update the group defined by sectionTitle
    if (isArray(productMap[sectionTitle])) {
      productMap[sectionTitle].push(product)
    } else {
      productMap[sectionTitle] = [product]
    }
  }
  return productMap
}
// sort function
const getSortValue = (ringWidth) => {
  const order = { Wide: 4, Standard: 3, Thin: 2, Halo: 1 }
  for (let item of Object.keys(order)) {
    if (ringWidth == item) {
      return order[item]
    }
  }
  return 0
}
export const sortByLabel = (index, order, options = {}) => {
  const productMap = index
  const sectionTitles = [...(order || [])]
  const firstInstance = options.firstInstance
  const filtered = (options.filtered === undefined) ? true : options.filtered
  const fallback = options.fallback || 'Shop All'
  // add any remaining section titles, default sorted
  for (let key of Object.keys(productMap || {}).sort()) {
    if (!sectionTitles.includes(key) && key !== fallback) {
      sectionTitles.push(key)
    }
  }
  // If there is no collection order in Contentful then we need to order the
  // section titles thick to thin.
  if (!order || (order.length === 0)) {
    sectionTitles.sort((a, b) => {
      // console.log(productMap[a][0].metafieldsMap)
      const aValue = getSortValue(
        get(productMap[a], '[0].metafieldsMap.width.value')
        // productMap[a][0].metafields.find((obj) => obj.key == "width").value
      )
      const bValue = getSortValue(
        get(productMap[b], '[0].metafieldsMap.width.value')
        // productMap[b][0].metafields.find((obj) => obj.key == "width").value
      )
      return bValue - aValue
    })
  }
  if (!firstInstance) {
    sectionTitles.push(fallback)
  }
  let validSectionTitles = []
  for (let title of sectionTitles) {
    if (productMap[title] && productMap[title].length) {
      validSectionTitles.push(title)
    }
  }
  console.log('[collection-sort]', sectionTitles.length, 'in', validSectionTitles.length, 'out')
  // console.log('collectionHelper', { productMap, sectionTitles })
  // return the needed list of product sections
  if (filtered) {
    return validSectionTitles
  } else {
    return firstInstance
      ? validSectionTitles.slice(0, 3)
      : validSectionTitles.slice(3)
  }
}
/**
 * sort products according to the given section label list `options.order`
 * which matches a metafield on each product.
 */
export const sortProducts = (products, options) => {
  if (options && options.order) {
    const productIndex = indexByLabel(products, options.order)
    const sections = sortByLabel(productIndex, options.order, options)
    let sortedProducts = []
    for (let section of sections) {
      // console.log(section)
      sortedProducts.push(...(productIndex[section] || []))
    }
    return sortedProducts
  } else {
    return products
  }
}
